'use client';

import { Flex, FlexProps } from '@chakra-ui/react';
import React from 'react';

type Props = FlexProps & {
  children: React.ReactNode;
};

const Container: React.FC<Props> = ({ children, ...rest }) => {
  return (
    <Flex flex="1" px="4" {...rest}>
      {children}
    </Flex>
  );
};

export default Container;
